import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { InputGroup, FormControl } from 'react-bootstrap';
import { modificaEmail, modificaSenha, modificaLogin, logarUsuario } from '../actions/AutenticacaoActions';

class login extends Component {

    constructor(props) {
        super(props);

        this.state = {
            server: localStorage.getItem('server') || window.location.origin
        }

        this._handleSubmit = this._handleSubmit.bind(this);
        this._handleServer = this._handleServer.bind(this);
    }

    _handleSubmit(event) {
        event.preventDefault();
        const { login, senha } = this.props;

        let str = this.state.server;
        let n = str.search(/:[0-9]{4,}/i);
        let server = this.state.server
        let protocol = window.location.protocol
        if(n < 0)
            server = this.state.server+':4001'

        let p = str.search(/^http/i);
        if(p < 0)
            server = protocol+'//'+server

        // Esta regra é simplesmente pra conseguir utilizar localhost e ngrok
        const word = "ngrok";
        const containsNgrok = server.toLowerCase().includes(word.toLowerCase());

        if(containsNgrok) {
            server = this.state.server
        }
        
        this.props.logarUsuario({ login, senha, server });
    }

    _handleServer(evt) {
        this.setState({ server: evt.target.value })
    }

    render() {
        return (
            <div className="login-box" style={{ background: '#d2d6de', borderRadius: '14px'}} >
                <div className="login-logo" id="retornoRecuperaSenha">
                    Acesso ao sistema
                </div>
 
                <div className="login-box-body" >

                    <p className="login-box-msg"> Loren</p>
                    <form onSubmit={ this._handleSubmit }>

                        <div className="form-group has-feedback">
                            <InputGroup className="mb-3">
                                <FormControl
                                    value={ this.state.server } 
                                    onChange={ this._handleServer } 
                                    placeholder="Server"
                                    aria-label="Server do callcenter"
                                    type="text" name="server" id="server"
                                    required
                                />
                                <InputGroup.Append>
                                <InputGroup.Text><i className="fa fa-server"></i></InputGroup.Text>
                                </InputGroup.Append>
                            </InputGroup>
                        </div>

                        <div className="form-group has-feedback">
                            <InputGroup className="mb-3">
                                <FormControl
                                    value={this.props.login} 
                                    onChange={ event => this.props.modificaLogin(event.target.value) } 
                                    placeholder="Login"
                                    aria-label="Login do usuario"
                                    type="text" name="login" id="login"
                                    required
                                />
                                <InputGroup.Append>
                                <InputGroup.Text><i className="fa fa-user"></i></InputGroup.Text>
                                </InputGroup.Append>
                            </InputGroup>
                        </div>
                        <div className="form-group has-feedback">

                            <InputGroup className="mb-3">
                                <FormControl
                                    value={this.props.senha} 
                                    onChange={ event => this.props.modificaSenha(event.target.value) } 
                                    placeholder="Senha"
                                    aria-label="Senha do usuario"
                                    type="password" name="senha" 
                                    required
                                />
                                <InputGroup.Append>
                                <InputGroup.Text><i className="fa  fa-lock"></i></InputGroup.Text>
                                </InputGroup.Append>
                            </InputGroup>
                        </div>
                
                        <div className="row">
                            <div className="col-md-8">    
                                <div className="checkbox icheck">
                                    
                                </div>                        
                            </div>

                            <div className="col-md-4">
                                <button id="btn_entrar" type="submit" className="btn btn-primary btn-block btn-flat " >Entrar</button>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        );
    }
}



const mapStateToProps = state => {
    return (
    {
        login: state.AutenticacaoReducer.login,
        email: state.AutenticacaoReducer.email,
        senha: state.AutenticacaoReducer.senha,
        server: state.AutenticacaoReducer.server,
        // errorLogin: state.AutenticacaoReducer.errorLogin,
        // loadingLogin: state.AutenticacaoReducer.loadingLogin,
    }
)}
  
  
  export default connect(mapStateToProps, { modificaEmail, modificaSenha, modificaLogin, logarUsuario })(login);

